import { useState } from 'react';
import { BSCourse } from '../bscourse/bscourse.component';
import { CSSCourse } from '../csscourse/csscourse.component';
import { HtmlCourse } from '../htmlcourse/htmlcourse.component';
import { JSCourse } from '../jscourse/jscourse.component';
import './reactcourse.css';

export function ReactCourse() {

	const [showReactCourse, setShowReactCourse] = useState(true);
	const [showJSCourse, setShowJSCourse] = useState(false);
	const [showHTMLCourse, setShowHTMLCourse] = useState(false);
	const [showCSSCourse, setShowCSSCourse] = useState(false);
	const [showBSCourse, setShowBSCourse] = useState(false);

    return (
        <>
            <main id="main" className="site-main r-course container" role="main">
			<article>
				<div>
					<div className="c-content">
						<span>
							<h3 className="r-header">
								ReactJS Fullstack Course: 
							</h3>
							<p className="m-1">
								<span className="r-color">
								<span className="font-size:1em;">Promising Hands On Expertise with course completion</span>
									+ Real time Project</span>
							</p>	
							<ul className="r-ul">
								<div className="r-li">
									<li>Menus</li>
									<li>Forms</li>
									<li>Validations</li>									
									<li>Routing</li>
									<li>Layouts</li>																											
									<li>Time Sheet grid</li>
								</div>
								<div className="r-li">
									<li>Popup</li>
									<li>Chat box</li>
									<li>Inline grids</li>
									<li>Shared Files</li>									
									<li>Comm. b/w pages</li>
									<li>Dynamic controls</li>
								</div>
							</ul>						
						</span>
					</div>
				</div>
			</article>
		    <article id="post-210" className="post-210 page type-page status-publish hentry">
				<div onclick="showHide('reactjscontent')">
					<header className="entry-header">
						<h1 className="entry-title" onClick={()=>{setShowReactCourse(!showReactCourse)}}>
							<span>ReactJS Syllabus</span>
							<span className="fa-caret-down-1"></span>
						</h1>
					</header>
				</div>
				{/* <!-- .entry-header --> */}
				{ showReactCourse && <div className="entry-content" id="reactjscontent" >
					
					<p><strong>ECMA Script 6</strong></p>

					<ul>
						<li>Classes</li>
						<li>Functions & Types</li>
						<li>Variables (let, const, var)</li>
						<li>Data Types</li>
						<li>Destructuring</li>
						<li>Modules</li>
						<li>Ternary Operator</li>
						<li>Spread Operator</li>
						<li>ES5 vs ES6</li>
						<li>ES6 Features</li>
					</ul>

					<p><strong>Topic 1: ReactJS Introduction</strong></p>

					<ul>
						<li>ReactJS History</li>
						<li>ReactJS Features &amp; Advantages</li>
						<li>React Versions</li>
					</ul>

					<p><strong>Topic 2: ReactJS Environment Setup</strong></p>

					<ul>
						<li>Node JS Setup, Overview</li>
						<li>NPM Overview</li>
						<li>NPM Commands</li>
					</ul>

					<p><strong>Topic 3: ReactJS Project Setup</strong></p>

					<ul>
						<li>Create first ReactJS Project</li>
						<li>Folder Structure</li>
						<li>&nbsp;Architecture</li>
					</ul>

					<p><strong>Topic 4: ReactJS – JSX</strong></p>

					<ul>
						<li>Introduction &amp; Using JSX</li>
						<li>Elements</li>
						<li>Nested Elements</li>
						<li>Attributes</li>
						<li>JavaScript Expression</li>
						<li>Naming Convention</li>
					</ul>

					<p><strong>Topic 5:</strong> <strong>ReactJS – Components</strong></p>

					<ul>
						<li>Functional Components</li>
						<li>Class Components</li>
					</ul>

					<p><strong>Topic 6: ReactJS Props &amp; State</strong></p>

					<ul>
						<li>
							Props
							<ul>
								<li>Using Props</li>
								<li>Default Props</li>
							</ul>
						</li>
						<li>
							State
							<ul>
								<li>Create State</li>
								<li>Set/ Update State</li>
								<li>Get State Values</li>
							</ul>
						</li>
					</ul>

					<p><strong>Topic 7: Nested Components</strong></p>

					<ul>
						<li>Refs &amp; Creating Refs</li>
						<li>Passing data from Parent to Child</li>
						<li>Passing data from Child to Parent</li>
					</ul>

					<p><strong>Topic 8: ReactJS Component Life Cycle</strong></p>

					<ul>
						<li>Life Cycle Methods</li>
					</ul>

					<p><strong>Topic 9: ReactJS Hooks</strong></p>

					<ul>
						<li>
							<span>Basic Hooks</span>
							<ul>
								<li>useState</li>
								<li>useEffect</li>
								<li>useContext</li>
							</ul>
						</li>
						<li>
							<span>Additional Hooks</span>
							<ul>
								<li>useReducer</li>
								<li>useCallback</li>
								<li>useMemo</li>
								<li>useRef</li>
								<li>useImperativeHandle</li>
								<li>useLayoutEffect</li>
								<li>useDebugValue</li>
							</ul>
						</li>
						<li>Custom Hooks</li>
					</ul>

					<p><strong>Topic 10: ReactJS with REST API</strong></p>

					<ul>
						<li>REST API Calling</li>
						<li>Post</li>
					</ul>

					<p><strong>Topic 11: ReactJS Props Validation</strong></p>

					<ul>
						<li>Introduction to validations</li>
						<li>Validating Props</li>
						<li>Use Cases</li>
					</ul>

					<p><strong>Topic 12: ReactJS Forms</strong></p>

					<ul>
						<li>Simple Form</li>
						<li>Complex Form</li>
						<li>Validations</li>
					</ul>

					<p><strong>Topic 13: ReactJS Events</strong></p>

					<ul>
						<li>Simple Events</li>
						<li>Child Events</li>
					</ul>

					<p><strong>Topic 14: ReactJS Router</strong></p>

					<ul>
						<li>Install React Route</li>
						<li>Introduction to Route</li>
						<li>Add Routes</li>
						<li>Protected Routes</li>
						<li>404 Not Found</li>
						<li>Default Route</li>
					</ul>

					<p><strong>Topic 15: Lazy loading</strong></p>

					<p><strong>Topic 16: ReactJS – Redux</strong></p>
				</div>}
			</article>
            <article>
				<div>
					<header className="entry-header" onClick={()=>{setShowJSCourse(!showJSCourse)}}>
						<h1 className="entry-title">
							<span>JavaScript Syllabus</span>
							<span className="fa-caret-down-1"></span>
						</h1>
					</header>
				</div>
				{showJSCourse && <div id="jscontent">
					<JSCourse></JSCourse>
				</div>}
			</article>
			<article>
				<div>
					<header className="entry-header" onClick={()=>{setShowHTMLCourse(!showHTMLCourse)}}>
						<h1 className="entry-title">
							<span>HTML Syllabus</span>
							<span className="fa-caret-down-1"></span>
						</h1>
					</header>
				</div>
				{showHTMLCourse&&<div id="htmlcontent">
					<HtmlCourse></HtmlCourse>
				</div>}
			</article>
			<article>
				<div>
					<header className="entry-header">
						<h1 className="entry-title" onClick={()=>{setShowCSSCourse(!showCSSCourse)}}>
							<span>CSS Syllabus</span>
							<span className="fa-caret-down-1"></span>
						</h1>
					</header>
				</div>
				{showCSSCourse && <div id="csscontent" className="display:none;">
					<CSSCourse></CSSCourse>
				</div>}
			</article>
			<article>
				<div>
					<header className="entry-header" onClick={()=>{setShowBSCourse(!showBSCourse)}}>
						<h1 className="entry-title">
							<span>BootStrap Syllabus</span>
							<span className="fa-caret-down-1"></span>
						</h1>
					</header>
				</div>
				{showBSCourse && <div id="bscontent" className="display:none;">
					<BSCourse></BSCourse>
				</div>}
			</article>
			
		</main>
		<script type="text/javascript" src="../js/scroll.js"></script>
		<button onclick="topFunction()" id="myBtn" title="Go to top" className="scroll-btn">&#x21e7;</button>
        </>
    )
}